import { render, staticRenderFns } from "./HomeTopicHighlights.vue?vue&type=template&id=52858004&scoped=true"
import script from "./HomeTopicHighlights.vue?vue&type=script&lang=js"
export * from "./HomeTopicHighlights.vue?vue&type=script&lang=js"
import style0 from "./HomeTopicHighlights.vue?vue&type=style&index=0&id=52858004&prod&scoped=true&lang=css"
import style1 from "./HomeTopicHighlights.vue?vue&type=style&index=1&id=52858004&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52858004",
  null
  
)

export default component.exports